import useResources from "./use-resources";

interface PennylaneUser {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  created_at: string;
}

interface PennylaneCompany {
  id: number;
  name: string;
  reg_no: string;
  saas_plan: string;
  address: string;
  postal_code: string;
  city: string;
  created_at: string;
}

export function usePennylaneUsers() {
  const {
    resources: users,
    isLoading,
    error,
    mutate,
  } = useResources<PennylaneUser>("/admin/pennylane/users");
  return { users, isLoading, error, mutate };
}

export function usePennylaneCompanies() {
  const {
    resources: companies,
    isLoading,
    error,
    mutate,
  } = useResources<PennylaneCompany>("/admin/pennylane/companies");
  return { companies, isLoading, error, mutate };
}
